import Vue from 'vue'
import Select2 from 'vue3-select2-component'

Vue.component('Select2', Select2)
